import type { ExtendedPlanSelectorData } from './dataTransformers'

/**
 * Determines if the plan override confirmation dialog should be shown
 * based on the subscription state.
 *
 * The dialog is shown when the subscription has either:
 * - A scheduled update (plan change or quantity change scheduled for future)
 * - A cancellation scheduled for the end of the period
 *
 * @param subscription - The current subscription data
 * @returns true if the override dialog should be shown
 */
export const shouldShowPlanOverrideDialog = (
  subscription: ExtendedPlanSelectorData['subscription'],
): boolean => {
  return Boolean(
    subscription?.scheduledUpdate || subscription?.isCanceledAtPeriodEnd,
  )
}
